import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types'
import { cloneDeep } from 'lodash';
import {
    defaultNavigation,
} from './navigations'

export class InitialNavigationsProvider {
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;


    get navigation(): Navigation {
        return {
            default   : cloneDeep(this._defaultNavigation),
        }
    }
}

export class InitialNavigations {
    static get navigations(): Navigation {
        return new InitialNavigationsProvider().navigation;
    }
}
